import React from "react";
import Title from "@streeteasy/design-system/deprecated/Title";
import { node } from "prop-types";

import * as S from "./styled";

const ErrorCaught = ({ children }) => (
  <S.ErrorContainer>
    <S.ErrorIcon />
    <Title type="primarySm">Something went wrong</Title>
    {children}
  </S.ErrorContainer>
);

ErrorCaught.propTypes = {
  children: node
};
ErrorCaught.defaultProps = {
  children: null
};

export default ErrorCaught;
